export enum CouponValidation {
  ValidCoupon = 0,
  InvalidAll = 1,
  InvalidConfig = 2,
  InvalidDate = 3,
  InvalidOncePer = 4,
  InvalidMultiple = 5,
  InvalidThreshold = 6,
  InvalidUndefined = 7,
}
